import Keycloak from 'keycloak-js';

const keycloak = Keycloak({
  url: (window as any).NX_HOST_KEYCLOAK || process.env.NX_HOST_KEYCLOAK || '',
  realm: (window as any).NX_REALM || process.env.NX_REALM || '',
  clientId: (window as any).NX_CLIENT_ID || process.env.NX_CLIENT_ID || '',
});

export { keycloak };
